// Per-user visibility rules for named report links in the menu (unchanged from the original sidebar).
const RESTRICTED = ["Mohammad Husni", "Aws ALi Jrdy", "Koul Mabrouk", "Rehmatullah Khan", "Rafi Mahmood", "Riaz Muhammad", "Saqib Umer"].map((n) => n.toLowerCase());

const GROUPS = {
  "ravin & miran": ["Ravin", "Miran", "Yad", "Awder"],
  "shohrat, magsat & ahmet": ["Shohrat", "Magsat", "Ahmet"],
  "anass fahmoune": ["Anass", "Amine"],
  "ardamehr shoev & abdul bari": ["Ardamehr", "Abdul"],
};

const startsWithAny = (name, prefixes) => prefixes.some((p) => name.startsWith(p.toLowerCase()));

export function isChildVisible(child, user) {
  const childName = child?.name?.trim().toLowerCase();
  const userName = user?.name?.trim().toLowerCase() || "";
  if (child?.name === "Payment History") return false;
  if (RESTRICTED.includes(childName)) return childName === userName;
  if (GROUPS[childName]) return startsWithAny(userName, GROUPS[childName]);
  return true;
}

/** Same rule as before: active when the path is in the item's childRoute list. */
export function isItemActive(item, pathname) {
  return item?.route === pathname || (Array.isArray(item?.childRoute) && item.childRoute.indexOf(pathname) !== -1);
}
